export const makeCnhCategoriesList = () => ['B', 'C', 'D', 'E', 'AB', 'AC', 'AD', 'AE'];
